import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import LineChart from '../components/lineChart'
import {useIntl} from 'react-intl'

export default function RedeemedPoints({
  total,
  data,
}: {
  total: string
  data: {
    series: {name: string; data: number[]}[]
    categories: string[]
  }
}) {
  const intl = useIntl()

  return (
    <div className='position-relative'>
      <div
        className='position-absolute d-flex flex-column justify-content-center align-items-center w-100 my-5'
        /* style={{ zIndex: 9999 }} */
      >
        <span className='fs-1 fw-bold'>
          {intl.formatMessage({id: 'ANALYTICS.REDEEMED_POINTS'})}
          <span className='position-relative z-50'>
            <OverlayTrigger
              trigger='hover'
              placement='top'
              overlay={
                <Tooltip>{intl.formatMessage({id: 'ANALYTICS.REDEEMED_POINTS_TOOLTIP'})}</Tooltip>
              }
            >
              <i className='bi bi-info-circle text-primary ms-1'></i>
            </OverlayTrigger>
          </span>
        </span>
        <span className='fs-2 text-extra-purple fw-bold'>{total}</span>
      </div>
      <div className='mt-5'>
        <LineChart data={data} />
      </div>
    </div>
  )
}
